export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    slag:string
    author: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    card: string;
    headerLogo: string;
    headerLogoGSK: string;
    headerLogoOneSource: string;
    headerLogoLine: string;
    footerLogo: string;
    gileadFooterLogoLeft: string;
    aseguaFooterLogoRight: string;
    warningIcon: string;
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    surveyId: string;
    clsProgramId: string;
    eligibilityFederalQuestion: string;
    eligibilityFederalYes: string;
    eligibilityFederalNo: string;
    eligibilityPrescribedQuestion: string;
    eligibilityPrescribedYes: string;
    eligibilityPrescribedNo: string;
    eligibilityCommercialInsuranceQuestion: string;
    eligibilityCommercialInsuranceYes: string;
    eligibilityCommercialInsuranceNo: string;
    eligibilityTermConditionQuestion: string;
    eligibilityTermConditionYes: string;
    eligibilityTermConditionNo: string;
    PharmacyEligibilityFederalQuestion: string;
    PharmacyEligibilityFederalYes: string;
    PharmacyEligibilityFederalNo: string;
    PharmacyEligibilityPrescribedQuestion: string;
    PharmacyEligibilityPrescribedYes: string;
    PharmacyEligibilityPrescribedNo: string;
    PharmacyEligibilityCommercialInsuranceQuestion: string;
    PharmacyEligibilityCommercialInsuranceYes: string;
    PharmacyEligibilityCommercialInsuranceNo: string;
    PharmacyEligibilityTermConditionQuestion: string;
    PharmacyEligibilityTermConditionYes: string;
    PharmacyEligibilityTermConditionNo: string;
    consentCheckboxQuestion: string;
    consentCheckboxAnswer: string;
    tncCheckboxQuestion: string;
    tncCheckboxAnswer: string;
    fcraCheckboxQuestion: string;
    fcraCheckboxAnswer: string;
    tcpaConsentCheckboxQuestion: string;
    tcpaConsentCheckboxAnswer: string;
    triangleUp: string;
    triangleDown: string;
    lockEnabled: string;
    lockPassword: string;
    phone: string;
    IsPatientAgeBetween6And17Question:string;
    IsPatientAgeBetween6And17AnswerYes:string;
    IsPatientAgeBetween6And17AnswerNo:string;
    pathQuestion:string;
    pathPatientAnswer:string;
    pathHCPAnswer:string;
    pathPharmacyAnswer:string;
    patientAuthFirstName:string;
    patientAuthFirstNameAnswer:string;
    patientAuthLastName:string;
    patientAuthLastNameAnswer:string;
    prescriberSignature:string;
    prescriberSignatureAnswer:string;
    pharmacistSignature:string;
    pharmacistSignatureAnswer:string;
    ncpdp:string;
    ncpdpAnswer:string;
    RECAPTCHA_KEY: string;
    optIn: string;
    optInAnsYes: string;
    optInAnsNo: string;
    aseguaTemplateId:string;
    aseguaBrandId:string;
    aseguaSenderId:string;
    gileadTemplateId:string;
    gileadBrandId:string;
    gileadSenderId:string;
    expireInDays:string;
    ConnectTo:string;
    externalProgramCode: string;
    externalPartyCode: string;
    documentType: string;
}
